// Псевдолокаль xx (?lang=xx): размеченный текст → «⟦Ṽóýţí···⟧» — видно неразмеченное (осталось
// голым русским), обрезки (длина +35%) и склейку кусков (скобки посреди фразы).
const MAP: Record<string, string> = {
  а: 'á', б: 'b', в: 'v', г: 'g', д: 'd', е: 'é', ё: 'ë', ж: 'zh', з: 'z', и: 'í', й: 'ý', к: 'k',
  л: 'ł', м: 'm', н: 'ñ', о: 'ó', п: 'p', р: 'ŕ', с: 'ś', т: 'ţ', у: 'ú', ф: 'f', х: 'kh', ц: 'ts',
  ч: 'č', ш: 'š', щ: 'šč', ъ: 'ʺ', ы: 'ý', ь: 'ʹ', э: 'è', ю: 'ǘ', я: 'ýá',
  a: 'á', e: 'é', i: 'í', o: 'ó', u: 'ú', y: 'ý', c: 'ç', n: 'ñ', s: 'š', z: 'ž',
}

function mapChar(ch: string): string {
  const low = ch.toLowerCase()
  const m = MAP[low]
  if (!m) return ch
  return ch === low ? m : m.charAt(0).toUpperCase() + m.slice(1)
}

export function pseudo(value: string): string {
  if (typeof value !== 'string' || !value) return value
  // теги <b>…</b> и разметку Trans не трогаем
  const body = value.replace(/(<[^>]+>)|([^<]+)/g, (_m, tag: string, text: string) =>
    tag ? tag : Array.from(text).map(mapChar).join(''),
  )
  const pad = '·'.repeat(Math.max(1, Math.round(value.length * 0.35)))
  return `⟦${body}${pad}⟧`
}
